//
//
//
//
//
//
//
//

export default {
  name: 'rb-toggle-bar',
}
